import {
  Box,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import { soloNumero } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import SelectFieldEntCarrerasComponent from '../../../entidad/ent_carreras/components/SelectFieldEntCarreras';
import { saveSeccionesAction } from '../SeccionesAction';

const FormSecciones = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entNivelesAcademicosStore = Redux.useSelector(
    (state) => state.entNivelesAcademicos,
  );
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const seccionesStore = Redux.useSelector((state) => state.secciones);

  const activo = seccionesStore.activo;

  const initData = {
    nombre: '',
    capacidad: 10,
    grupos: 1,
    turno: 'MAÑANA',
    desc: '',
    idEstatus: 1,
    idCarrera: '',
    idNivelAcademico: '',
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    nombre: false,
    capacidad: false,
    turno: false,
    idNivelAcademico: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!entidadesStore.activo) {
      notify('Falta seleccionar la entidad', { warning: true });
      return;
    }
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          idNivelAcademico: activo.nivelAcademico.id,
          idCarrera: activo.carrera?.id,
          idEstatus: activo.estatus.id,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!entidadesStore.activo) {
      notify('Falta seleccionar la entidad', { warning: true });
      return;
    }
    if (await _validDataForm()) {
      setLoadingSave(true);
      let res = await saveSeccionesAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          idEntidad: entidadesStore.activo.id,
          idCarrera:
            !data.idCarrera || data.idCarrera === '' || data.idCarrera === 0
              ? null
              : data.idCarrera,
        },
        seccionesStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        <Grid item xs={12} md={12}>
          <FormControl
            fullWidth
            size="small"
            required
            error={dataError.idNivelAcademico}
          >
            <InputLabel id={`label_${CONST.nivelAcademico.name}`}>
              {CONST.nivelAcademico.label}
            </InputLabel>
            <Select
              id={CONST.nivelAcademico.name}
              value={data.idNivelAcademico}
              labelId={`label_${CONST.nivelAcademico.name}`}
              label={CONST.nivelAcademico.label}
              required
              onChange={(e) =>
                _handleSetDataField(CONST.nivelAcademico.idName, e.target.value)
              }
            >
              {entNivelesAcademicosStore.all.map((el, index) => {
                return (
                  <MenuItem key={`ent-nivelAcademico-${index}`} value={el.id}>
                    {el.nivelAcademico.abrev} {el.nivelAcademico.nombre}
                  </MenuItem>
                );
              })}
            </Select>
            {dataError.idNivelAcademico && (
              <FormHelperText>{validMessage.required}</FormHelperText>
            )}
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.nombre.name}
            required
            label="Letra de la sección"
            value={data.nombre}
            onChange={(e) =>
              _handleSetDataField(CONST.nombre.name, e.target.value)
            }
            helperText={dataError.nombre ? validMessage.required : null}
            error={dataError.nombre}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            type="number"
            fullWidth
            size="small"
            id={CONST.capacidad.name}
            required
            label={CONST.capacidad.label}
            value={data.capacidad}
            onChange={(e) =>
              _handleSetDataField(
                CONST.capacidad.name,
                soloNumero(e.target.value),
              )
            }
            helperText={dataError.capacidad ? validMessage.required : null}
            error={dataError.capacidad}
            InputProps={{
              inputProps: { min: 1 },
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            type="number"
            fullWidth
            size="small"
            id={CONST.grupos.name}
            required
            label={CONST.grupos.label}
            value={data.grupos}
            onChange={(e) =>
              _handleSetDataField(CONST.grupos.name, soloNumero(e.target.value))
            }
            helperText={dataError.grupos ? validMessage.required : null}
            error={dataError.grupos}
            InputProps={{
              inputProps: { min: 1, max: 20 },
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <SelectFieldEntCarrerasComponent
            value={data.idCarrera}
            onChange={(idEntCarreras) =>
              _handleSetDataField(CONST.carrera.idName, idEntCarreras)
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth size="small" required error={dataError.turno}>
            <InputLabel id={`label_${CONST.turno.name}`}>
              {CONST.turno.label}
            </InputLabel>
            <Select
              id={CONST.turno.name}
              value={data.turno}
              required
              labelId={`label_${CONST.turno.name}`}
              label={CONST.turno.label}
              onChange={(e) =>
                _handleSetDataField(CONST.turno.name, e.target.value)
              }
            >
              <MenuItem value="MAÑANA">MAÑANA</MenuItem>
              <MenuItem value="NOCHE">NOCHE</MenuItem>
              <MenuItem value="SABATINOS">SABATINOS</MenuItem>
              <MenuItem value="TARDE">TARDE</MenuItem>
              <MenuItem value="MIXTO">MIXTO</MenuItem>
            </Select>
            {dataError.turno && (
              <FormHelperText>{validMessage.required}</FormHelperText>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <EstatusField
            value={data.idEstatus}
            onChange={(e) =>
              _handleSetDataField(CONST.estatus.idName, e.target.value)
            }
            isEstatus
            required
            error={dataError.idEstatus}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            label={CONST.desc.label}
            value={data.desc}
            multiline
            rows={2}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
            helperText={dataError.desc ? validMessage.required : null}
            error={dataError.desc}
          />
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            green={!activo}
            blue={activo}
            disabled={loadingSave}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormSecciones;
